import { useMutation } from 'react-query'

import { paymentMethodRepository } from '@webapp/platform/banking/data-access/repositories/PaymentMethodRepository'
import { type CreateExternalPaymentMethodPayload } from '@webapp/platform/banking/data-access/types/CreatePaymentMethodPayload'

export const useMutateCreateExternalPaymentMethod = () => {
  const { mutateAsync, isLoading } = useMutation({
    mutationFn: async (payload: CreateExternalPaymentMethodPayload) => {
      return paymentMethodRepository.createExternalPaymentMethod(payload)
    },
  })

  return {
    createExternalPaymentMethod: mutateAsync,
    isLoading,
  }
}
